import { observable, action, decorate, toJS } from 'mobx';
import DefaultTheme from '../components/shared/styled/Theme';
import Fetch from '../fetch/Fetch';
import { BrandingResponse, ErrorResponse } from '../fetch/types';
import { Theme } from '../types/theme';

class ThemeStore {
  requested = false;

  settings = DefaultTheme;

  transport: Fetch | null = null;

  constructor(transport: Fetch) {
    this.transport = transport;
  }

  setBranding(defaults: Theme, settings: BrandingResponse) {
    this.setRequested();
    this.settings.brand = { ...defaults.brand, ...settings.returns_branding };
    return this.settings;
  }

  setRequested() {
    this.requested = true;
  }

  getSettings() {
    return toJS(this.settings);
  }

  isBrandingLoaded() {
    return this.requested;
  }

  async fetchBranding(merchantReference: string) {
    try {
      const response = await this.transport?.getBranding(merchantReference);
      return this.setBranding(
        DefaultTheme,
        !(response as ErrorResponse).errors
          ? (response as BrandingResponse)
          : {}
      );
    } catch (e) {
      return this.setBranding(DefaultTheme, {});
    }
  }
}

decorate(ThemeStore, {
  settings: observable,
  requested: observable,
  setBranding: action,
  setRequested: action,
});

export default ThemeStore;
